import { Stack, useTheme } from "@mui/material";
import { Typography } from "@foodpilot/foods";
import { isWithinLastDay } from "./auditLogPresentation";
import { useAuditLogLabels } from "./useAuditLogLabels";

type AuditLogTimestampProps = {
    occurredAt: string;
};

export const AuditLogTimestamp = (props: AuditLogTimestampProps) => {
    const { occurredAt } = props;
    const theme = useTheme();
    const labels = useAuditLogLabels();

    return (
        <Stack direction="row" gap={theme.spacing(1)} alignItems="baseline" overflow="hidden">
            <Typography variant="small-regular" color="text.secondary" noWrap>
                {labels.utcDay(occurredAt)}
            </Typography>
            <Typography variant="small-semibold" noWrap>
                {labels.utcTime(occurredAt)}
            </Typography>
            {isWithinLastDay(occurredAt, new Date()) && (
                <Typography variant="small-regular" color="text.secondary" noWrap>
                    {labels.relativeTime(occurredAt)}
                </Typography>
            )}
        </Stack>
    );
};
